import React from "react";
import AddBudgetPageContent from "../components/addBudgetPageContent";

const AddBudget = () => {
  return <AddBudgetPageContent />;
};

export default AddBudget;
